import { ActionTracker } from '@dpdgroupuk/react-event-tracker';
import TagManager from 'react-gtm-module';
import { IS_DEV_MODE } from '../constants/env';

export default new ActionTracker({
  projectRef: 'DPDO',
  debug: IS_DEV_MODE,
  // TODO: Clarify values below
  //   productId: 56,
  //   url: `${process.env.REACT_APP_CPP_API_URL}/analytics`,
});

export const paymentEvent = checkoutResult => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  }); // Clear previous ecommerce data
  const tagManagerArgs = {
    dataLayer: {
      event: 'purchase',
      ecommerce: {
        currency: 'GBP', // currency of the order
        value: Number(checkoutResult.totals.amount || 0).toFixed(2), // Total amount of the whole order, excl. tax.
        tax: Number(checkoutResult.totals.taxAmount || 0).toFixed(2), // tax_amount
        transaction_id: checkoutResult.orderId, // order_id.
        // object for each parcel in order
        items: [],
      },
    },
  };
  checkoutResult.shipments.forEach(shipment => {
    shipment.parcelsData.forEach(parcel => {
      tagManagerArgs.dataLayer.ecommerce.items.push({
        item_name: parcel.weight,
        item_brand: shipment.deliveryDetails?.address?.countryCode || 'GB',
        // Answer to "Would you like us to collect your parcel" -> "SHOP_DROP_OFF" or "HOME_COLLECTION"
        item_variant: shipment.dropAtShop ? 'SHOP_DROP_OFF' : 'HOME_COLLECTION',
        // This is the chosen service in the section "Where should we deliver your parcel?" "PICKUP_LOCATION" or "HOME_DELIVERY"
        item_category: shipment.atPickup ? 'PICKUP_LOCATION' : 'HOME_DELIVERY',
        item_category2: shipment.liabilityValue, // extended cover
        price: parcel.price, // Unit price of current parcel excl. tax
        quantity: Number(parcel.quantity),
      });
    });
  });

  if (IS_DEV_MODE) {
    localStorage.setItem('tagManager', tagManagerArgs);
  }

  TagManager.dataLayer(tagManagerArgs);
};
